"use client";
import React, { useState, useRef, useEffect } from "react";
import { Wanchain1 } from "iconsax-react";
import { StandardUI } from "./StandardUI";



export function ChatUI({
    apiKey, openAi, }: {
        apiKey: string;
        openAi?: string;
    }) {


    const [isOpen, setIsOpen] = useState(false);
    const popoverRef = useRef<HTMLDivElement>(null);

    // Close popover when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // const buttonClasses = "rounded-full shadow-xl flex items-center gap-2 px-4 py-2 " +  "bg-gradient-to-r from-purple-700 to-purple-500 text-white " +"hover:from-purple-800 hover:to-purple-600 transition-all duration-200";

    return (
        <div
            className="fixed bottom-6 right-6 z-[9999]"
            style={{ all: "unset", position: "fixed", bottom: "1.5rem", right: "1.5rem", zIndex: 9999 }}
            ref={popoverRef}
        >
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="rounded-full shadow-xl flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-700 to-purple-500 text-white hover:from-purple-800 hover:to-purple-600"
            >
                <Wanchain1 size="22" />
                <span className="font-semibold text-sm">Ask Hostie!</span>
            </button>

            {isOpen && (
                // <div className="absolute  bottom-full mb-3 right-0 w-85 p-0 shadow-2xl border border-gray-200 rounded-xl bg-white">
                //     {/* Place your chat content here */}
                //     <StandardUI apiKey={apiKey} openAi={openAi}/>
                // </div>

                // <div className="absolute fixed top-20  right-20 w-80 p-0 shadow-2xl border border-gray-200 rounded-xl bg-white">
                //     <StandardUI apiKey={apiKey} openAi={openAi} />
                // </div>



                <div className="absolute bottom-full mb-3 right-0 w-80 p-0 shadow-2xl border border-gray-200 transition-all duration-200 rounded-xl bg-white">
                    <StandardUI apiKey={apiKey} openAi={openAi} />
                </div>




            )}
        </div>
    )
}
